import { ReactTFC } from "../../../../../../utils/fp/missing-ts-parts";
import React from "react";
import { CheckoutVisualButton } from "../../shared/CheckoutVisualButton";

import { css } from "@emotion/react";
import cn from "classnames";

import { CSS_MQ } from "../../../../../../styles/breakpoints";

export const DualCheckoutVisualButton: ReactTFC<{
  isSelected: boolean;
  disabled: boolean;
  onClick: undefined | (() => void);
  children: React.ReactNode;
  Extension: React.ReactNode;
  isOpened: boolean;
  isLoading?: boolean;
  className: string;
}> = props => {
  return (
    <CheckoutVisualButton
      isSelected={props.isSelected}
      onClick={props.onClick}
      disabled={props.disabled}
      as={props.Extension ? "div" : "button"}
      isLoading={props.isLoading}
      className={props.className}
    >
      <span css={styles}>{props.children}</span>

      <div
        className={cn({ hidden: !props.isOpened })}
        css={css`
          &.hidden {
            display: none;
          }
        `}
      >
        {props.Extension}
      </div>
    </CheckoutVisualButton>
  );
};

const styles = css`
  display: flex;
  gap: 12px;

  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
